import z from "zod";

export type QcBizLocationGroupOnly = z.infer<typeof QcBizLocationGroupOnlySchema>;
export const QcBizLocationGroupOnlySchema = z.object({
  color: z.string(),
  display_name: z.string(),
  id: z.number(),
  is_default: z.boolean(),
  is_show_chat_history: z.boolean(),
  name: z.string(),
  position: z.number(),
  tenant_id: z.number(),
});
